export enum FeatureModules {
    Analog = 'Analog',
    Edepot = 'Edepot'
}
